export const growthData = [
  {name: 'Page A', price: 1200},
  {name: 'Page B', price: 600},
  {name: 'Page C', price: 1200},
  {name: 'Page D', price: 600},
  {name: 'Page E', price: 900},
  {name: 'Page F', price: 1200},
  {name: 'Page G', price: 600},
  {name: 'Page H', price: 1200},
  {name: 'Page I', price: 600},
  {name: 'Page J', price: 900},
  {name: 'Page K', price: 900},
  {name: 'Page L', price: 900}

];
export const growth2Data = [
  {name: 'Page A', revenue: 1200},
  {name: 'Page B', revenue: 600},
  {name: 'Page C', revenue: 1200},
  {name: 'Page D', revenue: 600},
  {name: 'Page E', revenue: 900},
  {name: 'Page F', revenue: 1200},
  {name: 'Page G', revenue: 600},
  {name: 'Page H', revenue: 1200},
  {name: 'Page I', revenue: 600},
  {name: 'Page J', revenue: 900},
  {name: 'Page K', revenue: 900},
  {name: 'Page L', revenue: 900}

];

export const trafficData = [
  {name: 'Page A', income: 1200},
  {name: 'Page B', income: 600},
  {name: 'Page C', income: 1200},
  {name: 'Page D', income: 600},
  {name: 'Page E', income: 900},
  {name: 'Page F', income: 1200},
  {name: 'Page G', income: 600},
  {name: 'Page H', income: 1200},
  {name: 'Page I', income: 600},
  {name: 'Page J', income: 900},
  {name: 'Page K', income: 900},
  {name: 'Page L', income: 900}
];

export const trafficRaiseData = [
  {name: 'Page A', traffic: 1200},
  {name: 'Page B', traffic: 600},
  {name: 'Page C', traffic: 1200},
  {name: 'Page D', traffic: 600},
  {name: 'Page E', traffic: 900},
  {name: 'Page F', traffic: 1200},
  {name: 'Page G', traffic: 600},
  {name: 'Page H', traffic: 1200},
  {name: 'Page I', traffic: 600},
  {name: 'Page J', traffic: 900},
  {name: 'Page K', traffic: 900},
  {name: 'Page L', traffic: 900}
];


export const revenueData = [
  {name: 'Page A', revenue: 1200},
  {name: 'Page B', revenue: 600},
  {name: 'Page C', revenue: 1200},
  {name: 'Page D', revenue: 600},
  {name: 'Page E', revenue: 900},
  {name: 'Page F', revenue: 1200},
  {name: 'Page G', revenue: 600},
  {name: 'Page H', revenue: 1200},
  {name: 'Page I', revenue: 600},
  {name: 'Page J', revenue: 900},
  {name: 'Page K', revenue: 900},
  {name: 'Page L', revenue: 900}
];

export const propertiesData = [
  {name: 'Page A', properties: 1200},
  {name: 'Page B', properties: 600},
  {name: 'Page C', properties: 1200},
  {name: 'Page D', properties: 600},
  {name: 'Page E', properties: 900},
  {name: 'Page F', properties: 1200},
  {name: 'Page G', properties: 600},
  {name: 'Page H', properties: 1200},
  {name: 'Page I', properties: 600},
  {name: 'Page J', properties: 900},
  {name: 'Page K', properties: 900},
  {name: 'Page L', properties: 900}
];
export const citiesData = [
  {name: 'Page A', cities: 200},
  {name: 'Page B', cities: 1200},
  {name: 'Page C', cities: 600},
  {name: 'Page D', cities: 1600},
  {name: 'Page D', cities: 1000},
  {name: 'Page H', cities: 2260},
  {name: 'Page K', cities: 800},
];
export const visitsData = [
  {name: 'Page A', visit: 200},
  {name: 'Page B', visit: 1200},
  {name: 'Page C', visit: 600},
  {name: 'Page D', visit: 1600},
  {name: 'Page D', visit: 1000},
  {name: 'Page H', visit: 2260},
  {name: 'Page K', visit: 800},
];

export const queriesData = [
  {name: 'Page A', queries: 200},
  {name: 'Page B', queries: 1200},
  {name: 'Page C', queries: 600},
  {name: 'Page D', queries: 1600},
  {name: 'Page D', queries: 1000},
  {name: 'Page H', queries: 2260},
  {name: 'Page K', queries: 800},
];

export const increamentData = [
  {name: 'Page A', price: 200},
  {name: 'Page B', price: 1200},
  {name: 'Page C', price: 600},
  {name: 'Page D', price: 1600},
  {name: 'Page D', price: 1000},
  {name: 'Page H', price: 2260},
  {name: 'Page K', price: 800},
];

export const increamentRevenueData = [
  {name: 'Page A', revenue: 200},
  {name: 'Page B', revenue: 1200},
  {name: 'Page C', revenue: 600},
  {name: 'Page D', revenue: 1600},
  {name: 'Page D', revenue: 1000},
  {name: 'Page H', revenue: 2260},
  {name: 'Page K', revenue: 800},
];

export const lineData = [
  {name: 'Page A', price: 200},
  {name: 'Page B', price: 1100},
  {name: 'Page C', price: 800},
  {name: 'Page D', price: 1700},
  {name: 'Page D', price: 600},
  {name: 'Page D', price: 1800},
  {name: 'Page D', price: 600},
];

export const lineData2 = [
  {name: 'Page A', traffic: 200},
  {name: 'Page B', traffic: 1100},
  {name: 'Page C', traffic: 800},
  {name: 'Page D', traffic: 1700},
  {name: 'Page D', traffic: 600},
  {name: 'Page D', traffic: 1800},
  {name: 'Page D', traffic: 600},
]
